import { EConsentUserType } from "@/contexts/EConsentContext";
import { useCallback } from "react";
import { useParams, useNavigate } from "react-router";


const useEConsentFormCancel = (user: EConsentUserType | undefined | null, eConsentGuid: string | undefined | null, onCancel: (() => void) | undefined) => {
    const params = useParams();
    const navigate = useNavigate();
    
    const onFormCancel = useCallback(() => {
        if (onCancel) {
            onCancel();
        }
        else if (user === EConsentUserType.Investigator) {
            navigate('..', { relative: 'path' });
        }
        else {
            navigate(`/trial-consent/econsent/${params.formDefinitionCode}/${eConsentGuid}`);
        }
    }, [navigate, params, onCancel, eConsentGuid, user]);

    return onFormCancel;
};

export default useEConsentFormCancel;
